import * as React from "react";
import sendRequest from "../../helpers/ajax";
import IListResults from "../../types/IListResults";
import IResponse from "../../types/IResponse";
import IStatusChangePostLog from "../../types/IStatusChangePostLog";
import IStatusChangePostLogSearchRequest from "../../types/IStatusChangePostLogSearchRequest";
import PostbackLogList from "./PostbackLogList";

interface IPostbackLogListContainerState {
    loading: boolean;
}

class PostbackLogListContainer extends React.Component<{}, IPostbackLogListContainerState> {
    constructor(props: {}) {
        super(props);

        this.state = { loading: false };

        this.search = this.search.bind(this);
    }

    public render() {
        return (
            <PostbackLogList loading={this.state.loading} search={this.search} />
        );
    }

    private async search(request: IStatusChangePostLogSearchRequest): Promise<IResponse<IListResults<IStatusChangePostLog>> | null> {
        this.setState({ loading: true });

        const response = await sendRequest<IResponse<IListResults<IStatusChangePostLog>>>("/api/messages/searchstatuschangepostlogs", "POST", request);

        this.setState({ loading: false });

        return response;
    }

}

export default PostbackLogListContainer;



// WEBPACK FOOTER //
// ./src/components/PostbackLogList/PostbackLogListContainer.tsx